<template>
  <div>
    <h1 class="subheading grey--text mb-3">
       Outras actividades
    </h1>
    <v-card flat class="ma-2 pa-2 card-rounded">
      <v-card-actions>
        <v-spacer />
        <ExcelExporter
          title="OtherActivities"
          label-field="text"
          :entries="otherActivitiesInfo"
          :components="excelComponents"
          :buttonText="`Exportar`"
        />
      </v-card-actions>
      <v-divider />
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="filteredOtherActivities || []"
        :pagination.sync="pagination"
        select-all
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:headers="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              />
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected">
            <td @click="props.selected = !props.selected">
              <v-checkbox :input-value="props.selected" primary hide-details />
            </td>
            <td class="text-xs-center" @click="editLog(props.item)">
              {{ getTypeText(props.item.otherActivityType) }}
            </td>
            <td class="text-xs-center" @click="editLog(props.item)">
              {{ getSubTypeText(props.item.otherActivitySubType) }}
            </td>
            <td class="text-xs-center" @click="editLog(props.item)">
              {{ getActivityField(props.item) }}
            </td>
            <td class="text-xs-center" @click="editLog(props.item)">
              {{ props.item.title }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      :persistent="true"
      v-model="dialog"
      max-width="1000"
      lazy>
      <AddOtherActivityForm
        :form-data="selectedEntry"
        :close-me="() => (dialog = false)"
      />
    </v-dialog>
    <speed-dial :buttons="dialButtons" style="position: absolute" />
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import { mapGetters, mapActions } from 'vuex'
import AddOtherActivityForm from './AddOtherActivityForm'
import SpeedDial from '@/components/SpeedDial'
import ExcelExporter from '@/components/data-exporter/ExcelExporter'

export default {
  components: {
    AddOtherActivityForm: AddOtherActivityForm,
    SpeedDial,
    ExcelExporter
  },
  data: function () {
    return {
      selectedEntry: null,
      dialog: false,
      filterDialog: false,
      loading: false,
      pagination: {
        sortBy: 'title'
      },
      selected: [],
      activityField: [
        {
          type: 'postGraduateTraining',
          subType: '',
          fieldname: 'title'
        },
        {
          type: 'researchActivities',
          subType: '',
          fieldname: 'title'
        },
        {
          type: 'trainingOfOtherProfessionals',
          subType: 'medic',
          fieldname: 'institution'
        },
        {
          type: 'trainingOfOtherProfessionals',
          subType: 'nonMedic',
          fieldname: 'courseType'
        },
        {
          type: 'teachingActivity',
          subType: '',
          fieldname: 'institution'
        },
        {
          type: 'professionalAndScientificAssociations',
          subType: 'scientificSocieties',
          fieldname: 'societyName'
        },
        {
          type: 'professionalAndScientificAssociations',
          subType: 'organizations',
          fieldname: 'organizationName'
        },
        {
          type: 'organizationOfScientificEvents',
          subType: '',
          fieldname: 'event'
        },
        {
          type: 'positionsHeld',
          subType: '',
          fieldname: 'role'
        },
        {
          type: 'scientificReviewArbitration',
          subType: '',
          fieldname: 'eventMagazine'
        }
      ]
    }
  },
  created() {
    this.getOtherActivities()
  },
  computed: {
    ...mapGetters(['otherActivities']),
    otherActivitiesInfo() {
      return this.otherActivities.map(a => ({
        ...a,
        otherActivityTypeText: this.getTypeText(a.otherActivityType),
        otherActivitySubTypeText: this.getSubTypeText(a.otherActivitySubType)
      }))
    },
    excelComponents() {
      return [
        {
          id: 'otherActivityTypeText',
          text: 'Tipo'
        },
        {
          id: 'otherActivitySubTypeText',
          text: 'Programa de Doutoramento'
        },
        {
          id: 'title',
          text: 'Título'
        },
        {
          id: 'advisor',
          text: 'Orientador'
        },
        {
          id: 'institution',
          text: 'Instituição'
        },
        {
          id: 'duration',
          text: 'Duração (horas)'
        },
        {
          id: 'ects',
          text: 'Nº ECTS'
        },
        {
          id: 'promotingInstitution',
          text: 'Instituição promotora'
        },
        {
          id: 'promotor',
          text: 'Promotor'
        },
        {
          id: 'principalInvestigator',
          text: 'Investigador Principal'
        },
        {
          id: 'summary',
          text: 'Resumo'
        }
      ]
    },
    otherActivitySubTypes() {
      return [
        {
          text: 'Programa de Doutoramento',
          value: 'doctoralProgram'
        },
        {
          text: 'Curso de Pós-Graduação',
          value: 'graduateCourse'
        },
        {
          text: 'Programa de Mestrado',
          value: 'masterProgram'
        },
        {
          text: 'Investigação Observacional',
          value: 'observationalResearch'
        },
        {
          text: 'Investigação Experimental',
          value: 'experimentalResearch'
        },
        {
          text: 'Médicos',
          value: 'medic'
        },
        {
          text: 'Não médicos',
          value: 'nonMedic'
        },
        {
          text: 'Sociedades Científicas',
          value: 'scientificSocieties'
        },
        {
          text: 'Organizações',
          value: 'organizations'
        },
        {
          text: 'Pré-graduada',
          value: 'pre'
        },
        { text: 'Pós Graduada', value: 'post' }
      ]
    },
    otherActivityTypes() {
      return [
        {
          text: 'Formação Pós-graduada',
          value: 'postGraduateTraining'
        },
        { text: 'Actividades de Investigação', value: 'researchActivities' },
        {
          text: 'Formação de Outros Profissionais',
          value: 'trainingOfOtherProfessionals'
        },
        { text: 'Actividade Docente', value: 'teachingActivity' },
        {
          text: 'Associações Profissionais e Científicas',
          value: 'professionalAndScientificAssociations'
        },
        {
          text: 'Organização de Eventos Científicos',
          value: 'organizationOfScientificEvents'
        },
        {
          text: 'Cargos Desempenhados',
          value: 'positionsHeld'
        },
        {
          text: 'Revisão Científica',
          value: 'scientificReviewArbitration'
        }
      ]
    },
    filteredOtherActivities() {
      return this.otherActivities.filter(
        s =>
          !this.$route.query ||
          Object.keys(this.$route.query).length === 0 ||
          !this.$route.query.type ||
          this.$route.query.type === s.type
      )
    },
    headers() {
      return [
        {
          text: this.$t('common.Type'),
          value: 'type',
          align: 'center'
        },
        {
          text: this.$t('common.SubType'),
          value: 'subType',
          align: 'center'
        },
        {
          text: this.$t('common.activity'),
          value: 'activity',
          align: 'center'
        },
        {
          text: this.$t('common.Title'),
          value: 'title',
          align: 'center'
        }
      ]
    },
    dialButtons() {
      return [
        {
          icon: 'add',
          color: 'indigo',
          action: () => {
            this.selectedEntry = {}
            this.dialog = true
          }
        },
        {
          icon: 'edit',
          color: 'primary',
          action: () => {
            if (this.selected && this.selected.length === 1) {
              this.selectedEntry = { ...this.selected[0] }
              this.selected = []
              this.dialog = true
            } else {
              this.$store.dispatch(
                'showErrorSnackbar',
                this.$t('common.PleaseSelectTheEntryToEdit')
              )
            }
          }
        },
        {
          icon: 'delete',
          color: 'red',
          action: () => {
            this.loading = 'error'
            this.$store
              .dispatch('deleteOtherActivities', this.selected)
              .then(() => {
                this.loading = false
                this.$store.dispatch(
                  'showSuccessSnackbar',
                  this.$t('courses.CoursesDeleted')
                )
              })
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions(['getOtherActivities']),
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = (this.otherActivities || []).slice()
    },
    getTypeText(typeValue) {
      const typeEntry = this.otherActivityTypes.find(
        at => at.value === typeValue
      )

      if (typeEntry) {
        return typeEntry.text
      } else {
        return ''
      }
    },
    getSubTypeText(typeValue) {
      const typeEntry = this.otherActivitySubTypes.find(
        at => at.value === typeValue
      )

      if (typeEntry) {
        return typeEntry.text
      } else {
        return ''
      }
    },

    getActivityField(item) {
      const fieldname =
        this.activityField.find(
          x =>
            x.type === item.otherActivityType &&
            x.subType === item.otherActivitySubType
        ) || this.activityField.find(x => x.type === item.otherActivityType)
      return item[fieldname.fieldname]
    },

    editLog(item) {
      this.selectedEntry = item
      this.dialog = true
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style></style>
